// Letters by Lanternlight — shared behaviour
// Works across multiple instances of any section on one page.
document.addEventListener('DOMContentLoaded', function () {

  // ---- footer year ----
  document.querySelectorAll('[data-lbl-year]').forEach(function (el) {
    el.textContent = new Date().getFullYear();
  });

  // ---- guided chooser (per section instance) ----
  document.querySelectorAll('[data-lbl-chooser]').forEach(function (root) {
    var buttons  = Array.from(root.querySelectorAll('.lbl-intent button'));
    var cards    = Array.from(root.querySelectorAll('.lbl-story'));
    var recName  = root.querySelector('[data-lbl-recname]');
    var recWhy   = root.querySelector('[data-lbl-recwhy]');
    var gridNote = root.querySelector('[data-lbl-gridnote]');

    function apply(intent, btn) {
      if (btn) {
        if (recName && btn.dataset.recname) recName.textContent = btn.dataset.recname;
        if (recWhy  && btn.dataset.recwhy)  recWhy.textContent  = btn.dataset.recwhy;
        if (gridNote && btn.dataset.note)   gridNote.textContent = btn.dataset.note;
      }
      var matched = cards.filter(function (c) {
        return (c.dataset.tags || '').split(' ').indexOf(intent) !== -1;
      });
      // If the recommendation covers everything, highlighting everything says nothing.
      var highlight = matched.length < cards.length ? matched : [];
      cards.forEach(function (c) {
        c.classList.toggle('match', highlight.indexOf(c) !== -1);
      });
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        apply(btn.dataset.intent, btn);
      });
    });

    // default: whichever button is pre-pressed, else the first
    var initial = buttons.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0] || buttons[0];
    if (initial) apply(initial.dataset.intent, initial);
  });

});
